import React, {Component} from 'react';
import { connect } from 'react-redux';

import { t } from 'l10n';

import Loading from 'components/Loading';
import MessageList from 'components/message/MessageList';
import MessageHeader from 'components/message/MessageHeader';

import {
    getMemberMessageList,
    clearMessageListInMemory
} from 'reducers/memberMessageList';

class MessageListTrash extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showTopButton: false
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    fetchData({dispatch, location, params}) {
        const reducerParams = {
            trash: 1,
            ...params
        };

        return dispatch(getMemberMessageList(reducerParams));
    }

    componentDidMount() {
        const { dispatch, location } = this.props;

        this.fetchData({dispatch, location});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        let action = clearMessageListInMemory();
        dispatch(action);
        
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(e) {
        const {
            scrollTop,
            scrollHeight,
            offsetHeight,
        } = e.target.scrollingElement;

        const bottom = scrollTop + offsetHeight == scrollHeight;

        const {
            offset,
            trashCount
        } = this.props.memberMessageList;

        this.setState({showTopButton: scrollTop !== 0})

        if(scrollTop !== 0 && bottom && offset !== trashCount) {
            const { dispatch, location } = this.props;
            const params = {
                offset: offset
            };

            this.fetchData({dispatch, location, params});
        }
    }


    render() {
        if(!this.props.memberMessageList.messageList) return <Loading centered/>;
        
        const { 
            newCount,
            totalCount,
            trashCount,
            messageList
        } = this.props.memberMessageList;

        const { showTopButton } = this.state;

        return (
            <div className="member-message trash">
                <MessageHeader
                    newCount={newCount}
                    trashCount={trashCount}
                    messagesCount={totalCount}
                    showForm={false}
                    title={t('Trash')}
                />
                <MessageList 
                    trash={true}
                    messageList={messageList}
                    showTopButton={showTopButton && trashCount !== 0}
                />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberMessageList: state.memberMessageList
    }),
    null
)(MessageListTrash)


// WEBPACK FOOTER //
// ./src/containers/member/MessageListTrash.js